const donationConfig = {
    regular: [
        { amount: 300, description: 'Cesta poradkyně rané péče do rodiny' },
        { amount: 500, description: 'Speciální pomůcka pro děti s postižením zraku' },
        { amount: 1000, description: '1 hodina odborné konzultace v rodině' }
    ],
    onetime: [
        { amount: 1000, description: '1 hodina odborné konzultace v rodině' },
        { amount: 2000, description: 'Posouzení zrakových funkcí' },
        { amount: 5000, description: 'Komplexní péče pro 1 rodinu na měsíc' }
    ]
};

const periodicityConfig = {
    regular: '730',
    onetime: '99999'
};

document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.gift form');

    if (!form) return;

    const typeRadios = document.querySelectorAll('.gift input[name="type"]');
    const amountCardsContainer = document.querySelector('.gift__cards');
    const customAmountSection = document.querySelector('.gift__custom');
    const customAmountInput = customAmountSection.querySelector('input[type="number"]');

    let currentType = 'regular';
    let selectedAmount = 300;
    let isCustomAmount = false;

    customAmountSection.style.display = 'none';

    function renderAmountCards(type, animate = false) {
        const amounts = donationConfig[type];

        amountCardsContainer.innerHTML = amounts.map((item, index) => `
            <label>
                <input type="radio" name="amount" value="${item.amount}" ${index === 0 ? 'checked' : ''}>
                <span>${item.amount} Kč</span>
                ${item.description}
            </label>
        `).join('') + `
            <label>
                <input type="radio" name="amount" value="custom">
                <span>Vlastní částka</span>
            </label>
        `;

        if (animate) {
            const amountSpans = amountCardsContainer.querySelectorAll('span');
            amountSpans.forEach(span => {
                if (span.textContent.includes('Kč')) {
                    span.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
                    span.style.opacity = '0';
                    span.style.transform = 'translateY(-5px)';

                    setTimeout(() => {
                        span.style.opacity = '1';
                        span.style.transform = 'translateY(0)';
                    }, 50);
                }
            });
        }

        attachAmountListeners();
    }

    function attachAmountListeners() {
        const amountRadios = document.querySelectorAll('.gift input[name="amount"]');

        amountRadios.forEach(radio => {
            radio.addEventListener('change', function() {
                if (this.value === 'custom') {
                    isCustomAmount = true;
                    customAmountSection.style.display = 'flex';
                    selectedAmount = parseInt(customAmountInput.value) || 100;
                } else {
                    isCustomAmount = false;
                    customAmountSection.style.display = 'none';
                    selectedAmount = parseInt(this.value);
                }
            });
        });
    }

    typeRadios.forEach((radio, index) => {
        radio.addEventListener('change', function() {
            currentType = index === 0 ? 'regular' : 'onetime';
            renderAmountCards(currentType, true);
            isCustomAmount = false;
            customAmountSection.style.display = 'none';
            selectedAmount = donationConfig[currentType][0].amount;
        });
    });

    customAmountInput.addEventListener('input', function() {
        if (isCustomAmount) {
            selectedAmount = parseInt(this.value) || 0;
        }
    });

    form.addEventListener('submit', function(e) {
        e.preventDefault();

        const baseUrl = 'https://muj.eda.cz/donate/menime-zivot-rodinam-deti-s-postizenim-zraku';
        const periodicity = periodicityConfig[currentType];
        const amount = selectedAmount;

        const url = `${baseUrl}?f=1&amount=${amount}&periodicity=${periodicity}&locked=1&utm_source=web`;

        window.open(url, '_self');
    });

    renderAmountCards(currentType);
});
